const ALP_Constants = {
  contentType: 'article',
  POPUPBUTTON:'popupbutton',
  DiscoverMoreButton:'discoverMoreButton',
  LEFTARROWLABEL:'leftarrowlabel',
  MENUBUTTON:"Menu: ícone de produtos",
  LINKBUTTON:'linkbutton',
  GOSTEI_BOTAO:'Eu gosto',
  NAO_GOSTEI_BOTAO:'Não gosto',
  IMAGEBUTTON:'imageButton',
  RATING:'RatingButton',
  data_source_mode_option: {
    API_DATA: 'API_DATA',
    CONTENTFUL_DATA: 'CONTENTFUL_DATA',
  },
  filter_list: [
    {
      filter: {},
      sort: null,
      page: 1,
    },
  ],
  lazy_load_consts: {
    current_page: 1,
    per_page: 6,
    total_page: '',
  },
  algoliaQueryFormat: {
    hitsPerPage: 6,
    page: 0,
    attributesToRetrieve:  [
        'locale',
        'url',
        'slug',
        'contentType',
        'articleTitle',
        'shortDescription',
        'GAPopularityCount',
        'heroImage',
        'variant',
      ],

    facets: []
  },
  sorting_dropdown_list: {
    'most-viewed': {
      name: 'MAIS BEM AVALIADOS',
      value: 'most-viewed',
      sort_field: 'GAPopularityCount',
      sort_direction: 'desc',
    },
    newest: {
      name: 'ÚLTIMOS LANÇAMENTOS',
      value: 'newest',
      sort_field: 'articleAddDate',
      sort_direction: 'desc',
    },
    'a-z': {
      name: 'NOME DE A-Z',
      value: 'a-z',
      sort_field: 'articleTitle',
      sort_direction: 'asc',
    },
    'z-a': {
      name: 'NOME DE Z-A',
      value: 'z-a',
      sort_field: 'articleTitle',
      sort_direction: 'desc',
    },
  },
};

export default ALP_Constants;
